<template>
	<el-row>
		<el-dialog :visible.sync="dialogVisible" title="选择方案方向" center width="30%">
			<el-form label-position="right" label-width="80px" :model="info" ref="info">
				<el-form-item label="类型" prop="scenarioProgramme" :rules="[{
					required: true,message: '请选择类型',trigger: 'change'
				}]">
					<el-select v-model="info.scenarioProgramme">
						<el-option v-for="(item,index) in scenarioTypes" :key="index" :label="item.label"
							:value="item.value"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button @click="sumbit()" type="primary">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<template v-if="info2.length>0">
			<div v-for="(item,index) in info2" :key="index"
				style="width: 100%;margin-bottom: 50px;background-color: #f2f2f2;">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="剧本天数:">
						<span>第{{item.dayNumber}}天</span>
					</el-form-item>
					<el-form-item label="剧本类型">
						<span v-if="item.scenarioProgramme == '01'">构建信任</span>
						<span v-if="item.scenarioProgramme == '02'">拓新吸粉</span>
						<span v-if="item.scenarioProgramme == '03'">私聊话术</span>
						<span v-if="item.scenarioProgramme == '04'">产品种草</span>
						<span v-if="item.scenarioProgramme == '05'">课程学习</span>
					</el-form-item>
					<el-form-item label="策略类型:">
						<el-select v-model="item.tacticsType" :disabled="item.disable">
							<el-option v-for="(item2,index) in options3" :key="index" :value="item2.value"
								:label="item2.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="策略描述:">
						<el-input v-model="item.tacticsDescription" style="width: 500px;" :disabled="item.disable">
						</el-input>
					</el-form-item>
					<el-form-item label="目标任务:">
						<el-input v-model="item.targetTask" min="0" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
							type="number" style="width: 100px;" :disabled="item.disable">
						</el-input>
						<span v-if="item.scenarioProgramme == '01' || item.scenarioProgramme == '04'">条/天</span>
						<span v-if="item.scenarioProgramme == '02' || item.scenarioProgramme == '03'">人/天</span>
						<span v-if="item.scenarioProgramme == '05'">节/天</span>
					</el-form-item>
					<el-form-item label="目标任务描述:">
						<el-input v-model="item.targetDescription" style="width: 500px;" :disabled="item.disable">
						</el-input>
					</el-form-item>
					<el-form-item label="场景动作:">
						<el-select v-model="item.scenario" :disabled="item.disable">
							<el-option v-for="(item2,index) in options4" :key="index" :value="item2.value"
								:label="item2.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="场景动作描述:">
						<el-input v-model="item.sceneDescription" style="width: 500px;" :disabled="item.disable">
						</el-input>
					</el-form-item>
					<el-form-item label="私聊用例:" v-if="item.scenarioProgramme == '03'">
						<div v-if="item.chatScriptAos.length>0">
							<div style="width: 500px;padding: 15px;display: flex;align-items: center;"
								v-for="(item2,index2) in item.chatScriptAos" :key="index2">
								<div style="border: 1px dotted #83d4f6;">
									<div v-for="(item3,index3) in item2" :key="index3" style="display: flex;">
										<div v-if="item3.chatType == '01'"
											style="display: flex;align-items: center;justify-content: flex-start;width: 400px;">
											<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/05.png"
												width="50px" height="50px" />
											<el-input v-model="item3.chatContent" style="width: 350px"
												:disabled="item.disable"></el-input>
											<el-button @click="del4(item3, index,index2,index3)"
												icon="el-icon-delete-solid" type="text" :disabled="item.disable">
											</el-button>
										</div>
										<div v-if="item3.chatType == '02'"
											style="display: flex;align-items: center;justify-content: flex-end;width: 400px;">
											<el-button @click="del4(item3, index,index2,index3)"
												icon="el-icon-delete-solid" type="text" :disabled="item.disable">
											</el-button>
											<el-input v-model="item3.chatContent" style="width: 350px"
												:disabled="item.disable"></el-input>
											<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/06.png"
												width="50px" height="50px" />
										</div>
									</div>
									<div style="display: flex;width: 400px;justify-content: space-around;">
										<el-button @click="add(1,index,index2)" type="text" :disabled="item.disable">
											左面加一条</el-button>
										<el-button @click="add(2,index,index2)" type="text" :disabled="item.disable">
											右面加一条</el-button>
									</div>
								</div>
								<div>
									<el-button @click="del2(index,index2)" icon="el-icon-delete"
										:disabled="item.disable">
									</el-button>
								</div>
							</div>
						</div>
						<el-button @click="addCircleIds2(index)" icon="el-icon-plus" :disabled="item.disable">
						</el-button>
					</el-form-item>
					<el-form-item label="活动用例:" v-if="item.scenarioProgramme != '05'">
						<template v-if="item.scenarioProgramme == '01' || item.scenarioProgramme == '04'">
							<div v-if="item.circleIds.length>0" style="display: flex;flex-wrap: wrap;">
								<div v-for="(item2,index2) in item.circleIds" :key="index2" style="margin-right: 10px;">
									<div
										style="width: 200px;height: 300px;border: 1px dashed #209CD3;padding: 5px;position: relative;">
										<div style="height: 50%;overflow: hidden;text-overflow: ellipsis;display:-webkit-box;
														-webkit-box-orient:vertical;-webkit-line-clamp:3;">
											{{item2.matInfo}}
										</div>
										<div style="text-align: center;height: 50%;">
											<video v-if="item2.img.substring(item2.img.length - 3) == 'mp4'"
												:src="item2.img" width="180px" height="100px" controls></video>
											<el-image v-else :src="item2.img" style="width: 100px;height: 100%;">
											</el-image>
										</div>
										<div style="position: absolute;right: 0;bottom: 0px;">
											<el-button type="text" icon="el-icon-delete" @click="del(index,index2,1)"
												:disabled="item.disable">
											</el-button>
										</div>
									</div>
								</div>
							</div>
						</template>
						<template v-if="item.scenarioProgramme == '03' || item.scenarioProgramme == '02'">
							<template v-if="item.activityCasesAos.length>0">
								<div v-for="(item2,index2) in item.activityCasesAos" :key="index2"
									style="width: 100%;display: flex;flex-wrap: wrap;">
									<div style="display: flex;align-items: center;width: 400px;">
										<el-form label-position="right" label-width="140px"
											style="border: 1px dotted #83d4f6;padding: 15px">
											<el-form-item label="商品id:">
												<el-input v-model="item2.commodityId" size="mini" type="number"
													:disabled="item.disable"></el-input>
											</el-form-item>
											<el-form-item label="活动名称:">
												<el-input type="textarea" v-model="item2.activityName" size="mini"
													:disabled="item.disable" maxlength="50" show-word-limit></el-input>
											</el-form-item>
											<el-form-item label="活动/商品图片:">
												<template v-if="item2.commodityPic.length==0">
													<el-upload :action="uploadUrl" list-type="picture-card"
														:on-success="getPictrueURL.bind(null, {'index':index2,'data':item})"
														accept=".jpg,.png" :file-list="item2.commodityPic">
														<i class="el-icon-plus" />
													</el-upload>
												</template>
												<div style="display: flex;align-items: center;" v-else>
													<el-image style="width: 150px;height: 150px;"
														:src="item2.commodityPic[0].url"></el-image>
													<div style="margin-left: 20px;">
														<el-button icon="el-icon-delete" size="small"
															@click="delImg(index,index2,item,item2)" type="primary"
															:disabled="item.disable"></el-button>
													</div>
												</div>
											</el-form-item>
										</el-form>
										<div>
											<el-button icon="el-icon-delete" @click="del(index,index2,2)"
												:disabled="item.disable"></el-button>
										</div>
									</div>
								</div>
							</template>
						</template>
						<el-button @click="addCircleIds(index)" icon="el-icon-plus" :disabled="item.disable">
						</el-button>
					</el-form-item>
					<el-form-item label="添加课件:" v-if="item.scenarioProgramme == '05'">
						<div v-if="item.coursewareIds.length>0" style="display: flex;flex-wrap: wrap;">
							<div v-for="(item2,index2) in item.coursewareIds" :key="index2" style="margin-right: 10px;">
								<div
									style="width: 200px;height: 300px;border: 1px dashed #209CD3;padding: 5px;position: relative;">
									<div style="height: 40%;overflow: hidden;text-overflow: ellipsis;display:-webkit-box;
													-webkit-box-orient:vertical;-webkit-line-clamp:3;">
										{{item2.matInfo}}
									</div>
									<div style="text-align: center;">
										<el-image :src="item2.img" style="width: 100px;height: auto;">
										</el-image>
									</div>
									<div style="position: absolute;right: 0;bottom: 0px;">
										<el-button type="text" icon="el-icon-delete" @click="del(index,index2,3)"
											:disabled="item.disable">
										</el-button>
									</div>
								</div>
							</div>
						</div>
						<el-button @click="addCircleIds(index)" icon="el-icon-plus" :disabled="item.disable">
						</el-button>
					</el-form-item>
					<div v-if="$route.query.releasePhase == '0'">
						<el-form-item v-if="info2.length>0">
							<el-button @click="editor(index)" v-if="item.cz">
								{{item.disable ? '编辑' : '完成'}}
							</el-button>
							<el-button @click="sumbit2(index)" size="medium" v-if="!item.cz">确认</el-button>
							<el-button v-if="item.cz &&(index + 1) - 0 == info2.length" @click="delInfoList(item,index)"
								size="medium">删除</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
		</template>
		<div v-if="$route.query.releasePhase == 0">
			<el-row v-if="isShow">
				<el-button @click="addList()">
					添加执行动作+
				</el-button>
			</el-row>
		</div>
		<el-dialog :visible.sync="dialogVisible2" title="请选择圈文素材" width="80%" center>
			<el-row>
				<el-col :span="6">
					<span style="margin-right: 10px;">素材分类</span>
					<el-cascader v-model="query.arr" :options="options7" :props="props"></el-cascader>
				</el-col>
				<el-col :span="6">
					<span style="margin:0 10px;">圈文类型</span>
					<el-select v-model="query.id2">
						<el-option v-for="(item2,index) in options5" :key="index" :value="item2.value"
							:label="item2.label">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="6">
					<span style="margin:0 10px;">针对人设</span>
					<el-select v-model="query.matPersona">
						<el-option v-for="(item2,index) in options6" :key="index" :value="item2.memberLabelId"
							:label="item2.name">
						</el-option>
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.title4" style="width: 90%;" placeholder="请输入圈文名称"></el-input>
					<el-button @click="Query">筛选</el-button>
					<el-button @click="zhikong">置空</el-button>
				</el-col>
			</el-row>
			<el-table :data="tableData" style="margin-top: 10px;">
				<el-table-column label="ID" prop="matId"></el-table-column>
				<el-table-column label="圈文">
					<template slot-scope="scope">
						<div style="display: flex;justify-content: center;align-items: center;">
							<div>
								<video v-if="scope.row.matImg2.substring(scope.row.matImg2.length - 3) == 'mp4'"
									:src="scope.row.matImg2" width="100px" height="100px"></video>
								<el-image v-else :src="scope.row.matImg2" style="width: 50px;height: 50px;"></el-image>
							</div>
							<div style="text-align: center;">
								{{scope.row.matInfo }}
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="下载" prop="downNum"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="choose(scope.row)">选用</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin: 20px auto;width: 500px">
				<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
					:page-size="pageSize" :page-sizes="[30,60,100]" :total="total" :current-page.sync="pageNum"
					@size-change="handleSizeChange" @current-change="handleCurrentChange" />
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisible3" title="请选择课件" width="50%" center>
			<el-row>
				<el-col :span="6">
					<el-input v-model="query2.courseId" style="width: 90%;" placeholder="请输入课件id"></el-input>
				</el-col>
				<el-col :span="6">
					<el-input v-model="query2.courseName" style="width: 90%;" placeholder="请输入课件名字"></el-input>
				</el-col>
				<el-col :span="6">
					<el-button @click="Query2">筛选</el-button>
					<el-button @click="zhikong2()">置空</el-button>
				</el-col>
			</el-row>
			<el-table :data="tableData2" style="margin-top: 10px;">
				<el-table-column label="序号" prop="courseId">
				</el-table-column>
				<el-table-column label="图片">
					<template slot-scope="scope">
						<el-image :src="scope.row.themePic" style="width: 50px;height: 50px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column label="课件" prop="courseName">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="choose2(scope.row)">选用</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin: 20px auto;width: 500px">
				<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
					:page-size="pageSize" :page-sizes="[30,60,100]" :total="total" :current-page.sync="pageNum"
					@size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import httpClient from '../../util/request.js';
	export default {
		data() {
			return {
				uploadUrl: httpClient.imgUrl,
				hideUpload: false,
				isShow: true,
				dialogDisplay: false,
				dialogVisible: false,
				dialogVisible2: false,
				dialogVisible3: false,
				info: {
					dayNumber: '',
					scenarioProgramme: ""
				},
				info2: [],
				options: [],
				options2: [],
				options3: [],
				options4: [],
				options5: [],
				options6: [],
				options7: [],
				indexs: 0,
				query: {
					arr: [],
					id2: '',
					matPersona: '',
					title4: ''
				},
				query2: {
					courseId: "",
					courseName: ''
				},
				tableData: [],
				tableData2: [],
				pageNum: 1,
				pageSize: 30,
				total: 0,
				props2: {
					value: "id",
					label: "name",
					children: "sonList",
					multiple: true,
				},
				props: {
					value: "id",
					label: "name",
					children: "children",
				},
				scenarioTypes: [{
						value: '01',
						label: '构建信任'
					},
					{
						value: '02',
						label: '拓新吸粉'
					},
					{
						value: '03',
						label: '服务私聊'
					},
					{
						value: '04',
						label: '产品种草'
					},
					{
						value: '05',
						label: '课程学习'
					}
				]

			}
		},
		methods: {
			addCircleIds2(index) {
				let chatScriptAos = this.info2[index].chatScriptAos
				chatScriptAos.push([])
			},
			addCircleIds(index) {
				this.indexs = index
				if (this.info2[index].scenarioProgramme == '01' || this.info2[index].scenarioProgramme == '04') {
					this.dialogVisible2 = true
				}
				if (this.info2[index].scenarioProgramme == '02' || this.info2[index].scenarioProgramme == '03') {
					this.info2[index].activityCasesAos.push({
						commodityId: "", //商品ID
						activityName: "", //活动名称
						commodityPic: [] //商品图片
					})
				}
				if (this.info2[index].scenarioProgramme == '05') {
					this.dialogVisible3 = true
					this.getList2()
				}
			},
			del2(index, index2) {
				this.info2[index].chatScriptAos.splice(index2, 1)
			},
			Query() {
				this.getList()
			},
			choose(row) {
				this.info2[this.indexs].circleIds.push({
					id: row.matId,
					matInfo: row.matInfo,
					img: row.matImg2.split(',')[0]
				})
				this.dialogVisible2 = false
			},
			choose2(row) {
				this.info2[this.indexs].coursewareIds.push({
					id: row.courseId,
					matInfo: row.courseName,
					img: row.themePic
				})
				this.dialogVisible3 = false
			},
			add(num, index, index2, item2) {
				switch (num) {
					case 1: {
						this.info2[index].chatScriptAos[index2].push({
							chatType: "01",
							chatContent: "",
						});
						break;
					}
					case 2: {
						this.info2[index].chatScriptAos[index2].push({
							chatType: "02",
							chatContent: "",
						});
						break;
					}
				}
			},
			//删除聊天话术的某一条
			del4(item, index, index2, index3) {
				this.info2[index].chatScriptAos[index2].splice(index3, 1);
			},
			del(index, index2, item) {
				if (this.info2[index].scenarioProgramme == '01' || this.info2[index].scenarioProgramme == '04') {
					this.info2[index].circleIds.splice(index2, 1)
				}
				if (this.info2[index].scenarioProgramme == '02' || this.info2[index].scenarioProgramme == '03') {
					this.info2[index].activityCasesAos.splice(index2, 1)
				}
				if (this.info2[index].scenarioProgramme == '05') {
					this.info2[index].coursewareIds.splice(index2, 1)
				}
			},
			delInfoList(item, index) {
				let circleIds = []
				if (item.circleIds.length > 0) {
					item.circleIds.forEach(i => {
						circleIds.push(i.id)
					})
				}
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post('/api/plant/positions/updateScenarioDetail', {
						"id": item.id,
						"deleteStatus": 1,
						"scenarioType": "05",
					}).then(res => {
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getInfo()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			zhikong() {
				this.query = {
					arr: [],
					id2: '',
					matPersona: '',
					title4: '',
				}
			},
			zhikong2() {
				this.query2 = {
					courseId: "",
					courseName: ''
				}
				this.getList2()
			},
			editor(index) {
				let parentId = ''
				let parentId2 = ''
				switch (this.info2[index].scenarioProgramme) {
					case '01':
						parentId = 60
						parentId2 = 66
						break
					case '02':
						parentId = 61
						parentId2 = 67
						break
					case '03':
						parentId = 62
						parentId2 = 68
						break
					case '04':
						parentId = 63
						parentId2 = 69
						break
					case '05':
						parentId = 64
						parentId2 = 70
						break
				}
				this.getInfo3(parentId)
				this.getInfo4(parentId2)
				this.indexs = index
				this.info2[index].disable = !this.info2[index].disable
				let info = this.info2[index]
				if (info.disable) {
					if (info.tacticsType == '' || info.tacticsDescription == '' || info.dayNumber == '' || info
						.targetDescription == '' || info.scenario == '' ||
						info.sceneDescription == '') {
						this.$message.error('剧本详情未填写完整')
						this.info2[index].disable = false
						return false
					}
					let circleIds = []
					if (info.scenarioProgramme == '01' || info.scenarioProgramme == '04') {
						if (info.circleIds.length > 0) {
							info.circleIds.forEach(i => {
								circleIds.push(i.id)
							})
						} else {
							this.$message.error('活动用例未选择')
							this.info2[index].disable = false
							return false
						}
					}
					let chatScriptMap = {}
					if (info.scenarioProgramme == '03') {
						if (info.chatScriptAos.length > 0) {
							for (var i = 0; i < info.chatScriptAos.length; i++) {
								if (info.chatScriptAos[i].length > 0) {
									for (var q = 0; q < info.chatScriptAos[i].length; q++) {
										if (info.chatScriptAos[i][q].chatContent == '') {
											this.$message.error('私聊用例未填写完整')
											return false
										} else {
											delete info.chatScriptAos[i][q].createTime
											delete info.chatScriptAos[i][q].kinds
											delete info.chatScriptAos[i][q].updateTime
											delete info.chatScriptAos[i][q].deleteStatus
											delete info.chatScriptAos[i][q].parentId
											info.chatScriptAos[i][q].chatOrder = q + 1
											info.chatScriptAos[i][q].chatModel = '04'
											chatScriptMap[i] = info.chatScriptAos[i]
										}
									}
								} else {
									this.$message.error('私聊用例未填写完整')
									return false
								}
							}
						} else {
							this.$message.error('私聊用例未填写完整')
							return false
						}
					}
					let activityCasesAos = []
					if (info.scenarioProgramme == "02" || info.scenarioProgramme == "03") {
						if (info.activityCasesAos.length > 0) {
							for (var b = 0; b < info.activityCasesAos.length; b++) {
								if (info.activityCasesAos[b].activityName == "" || info.activityCasesAos[b].commodityId ==
									'' ||
									info.activityCasesAos[b].commodityPic.length == 0) {
									this.$message.error('活动用例未填写完整')
									return false
								} else {
									activityCasesAos.push({
										"id": info.activityCasesAos[b].id,
										"commodityId": info.activityCasesAos[b].commodityId,
										"activityName": info.activityCasesAos[b].activityName,
										"commodityPic": info.activityCasesAos[b].commodityPic[0].url
									})
								}
							}
						} else {
							this.$message.error('活动用例未填写完整')
							this.info2[index].disable = false
							return false
						}
					}
					let coursewareIds = []
					if (info.scenarioProgramme == '05') {
						if (info.coursewareIds.length > 0) {
							info.coursewareIds.forEach(i => {
								coursewareIds.push(i.id)
							})
						} else {
							this.$message.error('课件未选择')
							this.info2[index].disable = false
							return false
						}
					}
					this.$http.post('/api/plant/positions/updateScenarioDetail', {
							"id": info.id,
							// "parentId": this.$route.query.id, //剧本ID
							"scenarioType": this.scenarioType, //剧本类型 01: 构建信任02: 拓新吸粉03: 产品种草04: 私聊话术
							"tacticsType": info.tacticsType, //策略类型ID
							"scenarioProgramme": info.scenarioProgramme,
							"dayNumber": info.dayNumber, //剧本天数
							"tacticsDescription": info.tacticsDescription, //策略描述
							"targetTask": info.targetTask, //目标任务(条/天)
							"targetDescription": info.targetDescription, //目标任务描述
							"scenario": info.scenario, //情景动作ID
							"sceneDescription": info.sceneDescription, //情景动作描述
							"circleIds": circleIds, //圈文作品ID集合
							"deleteStatus": 0,
							//活动用例集合
							"activityCasesAos": activityCasesAos,
							//聊天话术集合
							"chatScriptMap": chatScriptMap,
							"coursewareIds": coursewareIds,
							"createPerson": this.$store.state.userInfo.id //创建人ID
						}).then(res => {
							if (res.data.status == 0) {
								this.$message.success(res.data.data)
								this.getInfo()
							} else {
								this.$message.error(res.data.msg)
								this.infoList[index].disable = false
							}
						})
						.catch((error) => {
							this.$message.error(error);
						})
				}
			},
			sumbit2(index) {
				let info = this.info2[index]
				if (info.tacticsType == '' || info.tacticsDescription == '' || info.dayNumber == '' || info
					.targetDescription == '' || info.scenario == '' ||
					info.sceneDescription == '') {
					this.$message.error('剧本详情未填写完整')
					return false
				}
				var p = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/;
				var p2 = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
				if (!p.test(info.targetTask)) {
					this.$message.error('目标任务天数不能为负数和0');
					return false
				}
				let circleIds = []
				if (info.scenarioProgramme == '01' || info.scenarioProgramme == '04') {
					if (info.circleIds.length > 0) {
						info.circleIds.forEach(i => {
							circleIds.push(i.id)
						})
					} else {
						this.$message.error('活动用例未选择')
						return false
					}
				}
				let activityCasesAos = []
				if (info.scenarioProgramme == "02" || info.scenarioProgramme == '03') {
					if (info.activityCasesAos.length > 0) {
						for (var a = 0; a < info.activityCasesAos.length; a++) {
							if (info.activityCasesAos[a].activityName == "" || info.activityCasesAos[a].commodityId ==
								'' ||
								info.activityCasesAos[a].commodityPic.length == 0) {
								this.$message.error('活动用例未填写完整')
								return false
							} else {
								activityCasesAos.push({
									"commodityId": info.activityCasesAos[a].commodityId,
									"activityName": info.activityCasesAos[a].activityName,
									"commodityPic": info.activityCasesAos[a].commodityPic[0].url
								})
							}
						}
					} else {
						this.$message.error('活动用例未填写完整')
						return false
					}
				}
				//03 私聊话术话术处理
				let chatScriptMap = {}
				if (info.scenarioProgramme == '03') {
					if (info.chatScriptAos.length > 0) {
						for (var i = 0; i < info.chatScriptAos.length; i++) {
							if (info.chatScriptAos[i].length > 0) {
								for (var q = 0; q < info.chatScriptAos[i].length; q++) {
									if (info.chatScriptAos[i][q].chatContent == '') {
										this.$message.error('私聊用例未填写完整')
										return false
									} else {
										info.chatScriptAos[i][q].chatOrder = q + 1
										info.chatScriptAos[i][q].chatModel = '04'
										chatScriptMap[i] = info.chatScriptAos[i]
									}
								}
							} else {
								this.$message.error('私聊用例未填写完整')
								return false
							}
						}
					} else {
						this.$message.error('私聊用例未填写完整')
						return false
					}
				}
				//05 课件
				let coursewareIds = []
				if (info.scenarioProgramme == '05') {
					if (info.coursewareIds.length > 0) {
						info.coursewareIds.forEach(i => {
							coursewareIds.push(i.id)
						})
					} else {
						this.$message.error('课件未选择')
						return false
					}
				}
				this.$http.post('/api/plant/positions/insertScenarioDetail', {
					"scenarioType": "05",
					"scenarioProgramme": info.scenarioProgramme, //剧本类型05构建信任06拓新吸粉08产品种草07私聊话术09课程学习
					"parentId": this.$route.query.id, //剧本ID
					"tacticsType": info.tacticsType, //策略类型ID
					"dayNumber": info.dayNumber, //剧本天数
					"tacticsDescription": info.tacticsDescription, //策略描述
					"targetTask": info.targetTask, //目标任务(条/天)
					"targetDescription": info.targetDescription, //目标任务描述
					"scenario": info.scenario, //情景动作ID
					"sceneDescription": info.sceneDescription, //情景动作描述
					"circleIds": circleIds, //圈文作品ID集合
					"activityCasesAos": activityCasesAos, //活动用例集合
					"chatScriptMap": chatScriptMap, //聊天话术集合
					"coursewareIds": coursewareIds, //课件集合
					"createPerson": this.$store.state.userInfo.id //创建人ID
				}).then(res => {
					if (res.data.status == 0) {
						this.$message.success(res.data.data)
						this.getInfo()
						this.isShow = true
					}
				})
			},
			addList() {
				this.dialogVisible = true
				this.info = {
					dayNumber: '',
					scenarioProgramme: ""
				}
			},
			sumbit() {
				this.$refs.info.validate(vai => {
					if (vai) {
						this.info2.push({
							dayNumber: this.info2.length + 1,
							scenarioProgramme: this.info.scenarioProgramme,
							tacticsDescription: "", //策略描述
							targetTask: "", //目标任务(条/天)
							targetDescription: "", //目标任务描述
							scenario: "", //情景动作ID
							sceneDescription: "", //情景动作描述
							circleIds: [], //圈文作品ID集合
							activityCasesAos: [], //活动用例集合
							chatScriptAos: [], //聊天话术集合
							coursewareIds: [],
							cz: false,
							disable: false
						})
						let parentId = ''
						let parentId2 = ''
						switch (this.info.scenarioProgramme) {
							case '01':
								parentId = 60
								parentId2 = 66
								break
							case '02':
								parentId = 61
								parentId2 = 67
								break
							case '03':
								parentId = 62
								parentId2 = 68
								break
							case '04':
								parentId = 63
								parentId2 = 69
								break
							case '05':
								parentId = 64
								parentId2 = 70
								break
						}
						this.dialogVisible = false
						this.isShow = false
						this.getInfo3(parentId)
						this.getInfo4(parentId2)
					}
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getList()
			},
			handleSizeChange2(size) {
				this.pageSize = size
				//重新请求数据
				this.getList2()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getList()
			},
			handleCurrentChange2(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getList2()
			},
			getPictrueURL(obj, res, file, fileList) {
				if (res.status == 1) {
					this.$message.error(res.msg)
					fileList.pop()
				} else {
					var index = obj.index;
					this.info2[this.indexs].activityCasesAos[index].commodityPic.push({
						url: res.data
					})
				}
			},
			delImg(index, index2, item, item2) {
				this.info2[index].activityCasesAos[index2].commodityPic = []
			},
			//圈文素材
			getList() {
				let categoryId = ''
				if (this.query.arr.length > 0) {
					categoryId = this.query.arr[1]
				}
				this.$http.post('/api/plant/groupMaterial/selectMaterial', {
					categoryId: categoryId,
					labelId: this.query.matPersona,
					matStyle: this.query.id2,
					matInfo: this.query.title4,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					this.total = res.data.data.total
					if (res.data.data.list.length > 0) {
						res.data.data.list.forEach(item => {
							item.matImg2 = item.matImg.split(',')[0]
						})
					}
					this.tableData = res.data.data.list
				})
			},
			getList2() {
				this.$http.post(`/api/course/clrCourse/selectCourse?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {
					courseId: this.query2.courseId,
					courseName: this.query2.courseName,
				}).then(res => {
					this.tableData2 = res.data.data.list
					this.total = res.data.data.total
				})
			},
			Query2() {
				this.getList2()
			},
			getInfo() {
				this.$http.post('/api/plant/positions/selectScenarioDetail', {
					"ids": [this.$route.query.id],
					"scenarioType": '05',
				}).then(res => {
					if (res.data.data.length > 0) {
						this.info2 = []
						res.data.data.forEach(i => {
							i.circleIds = []
							i.activityCasesAos = []
							i.coursewareIds = []
							if (i.groupMaterialVos) {
								i.groupMaterialVos.forEach(item => {
									i.circleIds.push({
										id: item.matId,
										img: item.matImg.split(',')[0],
										matInfo: item.matInfo
									})
								})
							}
							if (i.festivalCommodityVos) {
								i.festivalCommodityVos.forEach(item => {
									i.activityCasesAos.push({
										id: item.id,
										commodityId: item.commodityId, //商品ID
										activityPath: item.activityPath, //活动路径
										activityName: item.activityName, //活动名称
										commodityPic: [{
											url: item.commodityPic
										}]
									})
								})
							}
							if (i.coursewareVos) {
								i.coursewareVos.forEach(item => {
									i.coursewareIds.push({
										id: item.coursewareId,
										img: item.themePic,
										matInfo: item.courseName
									})
								})
							}
							var a = i.chatScriptVos;
							var b = [];
							if (a.length > 0) {
								a.forEach((item) => {
									b.push(item.chatRecords);
								});
							}
							var c = Array.from(new Set(b));
							var e = [];
							if (c.length > 0) {
								c.forEach((item, index) => {
									var d = [];
									d = a.filter((ele) => ele.chatRecords == item);
									if (d.length > 1) {
										e.push(d);
									}
								});
							}
							this.chatScriptVos = e;
							let parentId = '',
								parentId2 = ''
							switch (i.scenarioProgramme) {
								case '01':
									parentId = 60
									parentId2 = 66
									break
								case '02':
									parentId = 61
									parentId2 = 67
									break
								case '03':
									parentId = 62
									parentId2 = 68
									break
								case '04':
									parentId = 63
									parentId2 = 69
									break
								case '05':
									parentId = 64
									parentId2 = 70
									break
							}
							this.getInfo3(parentId)
							this.getInfo4(parentId2)
							this.info2.push({
								cz: true,
								id: i.id,
								scenarioProgramme: i.scenarioProgramme,
								scenarioType: i.scenarioType,
								tacticsType: i.tacticsType, //策略类型ID
								dayNumber: i.dayNumber, //剧本天数
								tacticsDescription: i.tacticsDescription, //策略描述
								targetTask: i.targetTask, //目标任务(条/天)
								targetDescription: i.targetDescription, //目标任务描述
								scenario: i.scenario, //情景动作ID
								sceneDescription: i.sceneDescription, //情景动作描述
								circleIds: i.circleIds, //圈文作品ID集合
								activityCasesAos: i.activityCasesAos, //活动用例集合
								chatScriptAos: e, //聊天话术集合
								coursewareIds: i.coursewareIds,
								disable: true
							})
						})
					} else {
						this.info2 = []
					}
				})
			},
			getInfo3(parentId) {
				this.options3 = []
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?parentId=${parentId}`, {}).then(res => {
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options3.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
			getInfo4(parentId) {
				this.options4 = []
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?parentId=${parentId}`, {}).then(res => {
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options4.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
			getInfo5() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=22`, {}).then(res => {
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options5.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})
			},
			//获取销售人群
			getInfo6() {
				this.$http.post("/api/plant/clrLabel/selectLabel", {
					"type": 4,
					"useStatus": 0
				}).then((res) => {
					res.data.data.forEach((item) => {
						this.options6.push({
							id: item.memberLabelId,
							name: item.name,
						})
					})
				});
			},
			//获取分类
			getInfo7() {
				this.$http
					.get(
						"/api/product/productCategory/paiCategory?pageSize=999&pageNum=1&paiStatus=1", {}
					)
					.then((res) => {
						this.options7 = res.data.data.list;
					});
			},
		},
		created() {
			this.getInfo()
			this.getInfo5()
			this.getInfo6()
			this.getInfo7()
		}
	}
</script>

<style scoped>
	::deep.hide .el-upload--picture-card {
		display: none;
	}
</style>